import CustomForm from "../../../Forms/CustomForm";
import { useAgent } from "../../../../contexts/AgentsContext";
import { useEffect, useState } from "react";

const DefineAgentVerProv = () => {
  const {
    ongoingAgentData,
    validateRequiredField,
    updateOngoingAgentDataL2,
    lookUpValues,
    isLoadingDropdownFields,
  } = useAgent();

  const [metadataValues, setMetadataValues] = useState({});

  useEffect(() => {
    setMetadataValues(ongoingAgentData?.metadata?.[0] || {});
  }, [ongoingAgentData?.metadata]);

  // Get metadata values
  const fields = [
    {
      name: "version_number",
      label: "Version",
      type: "text",
      required: true,
      placeholder: "Type Version",
      labelCls: "mas-form-label-regular",
      fieldCls: "custom-text-field-container",
      value: metadataValues?.version_number || "",
    },
    {
      name: "provider",
      label: "Provider",
      type: "dropdown",
      required: false,
      placeholder: "Select/Type to Search",
      labelCls: "mas-form-label-regular",
      fieldCls: "mas-cust-dd-primary mas-cust-dd-2",
      value: metadataValues?.provider || "",
      options:
        lookUpValues?.providers?.map((provider) => ({
          value: provider,
          label: provider,
        })) || [],
      loader: isLoadingDropdownFields?.providers,
      disabled: isLoadingDropdownFields?.providers,
    },
    {
      name: "documentation_url",
      label: "Documentation URL",
      type: "text",
      required: true,
      placeholder: "Type url",
      labelCls: "mas-form-label-regular",
      fieldCls: "custom-text-field-container",
      value: metadataValues?.documentation_url || "",
    },
  ];

  const handleFieldChange = (name, value) => {
    updateOngoingAgentDataL2(name, value);

    if (["version_number", "documentation_url"].includes(name)) {
      validateRequiredField(name, value);
    }
  };

  return (
    <>
      <CustomForm
        clsNames={"mas-cust-form-container"}
        cols={[6, 6]}
        fields={fields}
        onFieldChange={handleFieldChange}
      />
    </>
  );
};

export default DefineAgentVerProv;
